// extracted by mini-css-extract-plugin
export default {"language-dropdown":"LanguageDropdown_language-dropdown__Uby7N","language-dropdown__icon":"LanguageDropdown_language-dropdown__icon__itNX-"};